// Onglets du panneau de détail d'un lead auto (PER-2448), dans l'ordre de la
// barre d'accès de la carte. Le premier est l'onglet par défaut.
export const ONGLETS = [
  { id: "infos", libelle: "Infos et documents", court: "Infos", icone: "fa-file-alt" },
  { id: "commentaires", libelle: "Commentaires", court: "Commentaires", icone: "fa-comment-alt" },
  { id: "taches", libelle: "Tâches", court: "Tâches", icone: "fa-tasks" },
  { id: "agent", libelle: "Agent de tarification", court: "Agent", icone: "fa-robot" },
  { id: "retranscription", libelle: "Retranscription", court: "Retranscription", icone: "fa-headset" },
];
